 
<template>
  <v-card>
    <v-card-title> {{ $t("Henkilöstöedut") }} </v-card-title>
    <!-- actions -->

    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <v-spacer></v-spacer>

      <div class="d-flex align-center flex-wrap">
        <v-btn
          color="primary"
          class="mb-4"
          :to="{ name: 'admin-benefit-form' }"
        >
          <span>{{ $t("Uusi etu") }}</span>
        </v-btn>
      </div>
    </v-card-text>

    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-uppercase">
              {{ $t("Yritys") }}
            </th>
            <th class="text-uppercase">
              {{ $t("Otsikko") }}
            </th>
            <th class="text-uppercase">
              {{ $t("Julkaistu") }}
            </th>
          </tr>
        </thead>
        <draggable
          v-model="benefits"
          tag="tbody"
          handle=".handle"
          ghost-class="ghost"
          @end="sort(benefits)"
        >
          <tr v-for="benefit in benefits" :key="benefit.id">
            <td>
              <router-link
                :to="{ name: 'admin-benefit-form', params: { id: benefit.id } }"
              >
                {{ benefit.company }}
              </router-link>
            </td>
            <td>
              <router-link
                :to="{ name: 'admin-benefit-form', params: { id: benefit.id } }"
              >
                {{ benefit.title }}
              </router-link>
            </td>
            <td>
              <div>
                <v-icon v-if="benefit.published" size="24" color="success"
                  >{{ icons.mdiCheckboxMarkedCircle }}
                </v-icon>
                <v-icon v-else size="24" color="error"
                  >{{ icons.mdiCloseCircle }}
                </v-icon>
              </div>
            </td>
            <!-- <td>
              <v-icon class="handle">
                {{ icons.mdiCursorMove }}
              </v-icon>
            </td> -->
          </tr>
        </draggable>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import { onMounted, ref, watch } from "@vue/composition-api";
import adminApi from "@/api/admin";
import {
  mdiCheckboxMarkedCircle,
  mdiCloseCircle,
  mdiCursorMove,
  mdiPlus,
} from "@mdi/js";
import { useTranslations } from "@core/libs/i18n";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  setup() {
    const benefits = ref([]);
    const loading = ref(false);
    const { t } = useTranslations();

    // fetch data
    const fetchBenefits = async () => {
      loading.value = true;

      const response = await adminApi.getBenefits();
      benefits.value = response.data;

      loading.value = false;
    };

    // UnRegister on leave
    onMounted(() => {
      fetchBenefits();
    });

    // const sort = async () => {
    //   loading.value = true;

    //   const sortedIds = benefits.value.map((a) => a.id);
    //   await adminApi.sortBenefits(sortedIds);
    //   fetchBenefits();
    // };

    return {
      benefits,
      loading,
      icons: {
        mdiCheckboxMarkedCircle,
        mdiCloseCircle,
        mdiPlus,
        mdiCursorMove,
      },
      t,
    };
  },
};
</script>